import React from "react"

function ChecklistItem(props) {
    return (
        < div class="d-flex" >

            {/* Checkmark */ }
            < div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4" >
                <i class="fe fe-check"></i>
            </div >

            {/* Text */ }
            < p class="text-success" >{props.text}</p >
      
        </div >
    )
}

export default ChecklistItem